<template>
  <div>
    <div id="MyViewerDiv" class="model"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    let data = JSON.parse(decodeURIComponent(location.hash.split("=")[1]));
    this.viewers(data);
  },
  methods: {
    viewers(data) {
      this.$nextTick(() => {
        ZJWJ.LoadModel(data);
        var Interval = setInterval(() => {
          if (ZJWJ.modelLoad) {
            clearInterval(Interval);
            this.modelLoad = true;
          }
        }, 500);
      });
    },
  },
};
</script>

<style >
.model {
  width: 100vw;
  height: 100vh;
}
</style>